"use client";

import { Badge, Tooltip } from "@/components/ui";

import { useUser } from "@/contexts/user-provider";

import { PERMISSIONS, hasPermission } from "@/lib/permissions";

import { MedicationSummary } from "@/types/medication";

interface NeedsSignOffProps {
  medication: MedicationSummary;
  onRequestSignOff: (medication: MedicationSummary) => void;
}

export default function NeedsSignOff({
  medication,
  onRequestSignOff,
}: NeedsSignOffProps) {
  const { currentUser } = useUser();

  const shouldHide =
    !hasPermission(currentUser, PERMISSIONS.SIGN_OFF_MEDICATIONS) ||
    !!medication.signedOffDate ||
    !!medication.dosespotMedicationId;

  if (shouldHide) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRequestSignOff(medication);
  };

  return (
    <Tooltip content="Click to sign off this dose" triggerAsChild>
      <Badge variant="warning" className="cursor-pointer" onClick={handleClick}>
        Unsigned
      </Badge>
    </Tooltip>
  );
}
